export const CSR_STATUS = {
  inProgress: "In Progress",
  generating: "Generating CSR file",
  ready: "Ready for download",
  errored: "CSR generation failed",
};

export const SCS_STATUS = {
  inProgress: "In Progress",
  generating: "Generating SCS file",
  ready: "Ready for download",
  errored: "SCS generation failed",
};

export const LS_STATUS = {
  inProgress: "In Progress",
  generating: "Generating Lay Summary file",
  aiSummaryReady: "AI Lay Summary Generated",
  ready: "Ready for download",
  errored: "Lay Summary generation failed",
  readyToStart: "Ready to start Lay Summary generation",
};

export const FILE_UPLOAD_STATUS = {
  uploading: "UPLOADING",
  uploaded: "UPLOADED",
  processing: "PROCESSING",
  processed: "PROCESSED",
  errored: "ERROR",
};

export const FILES_STATUS = {
  progress: "progress",
  pending: "pending",
  warning: "warning",
  ready: "ready",
  readyEmpty: "readyEmpty",
};

export const DOCUMENT_TYPE = {
  csp: "CSP",
  sap: "SAP",
  tfl: "TFL",
};

export const PN_STATUS = {
  inProgress: "In Progress",
  generating: "Generating Patient Narrative",
  ready: "Ready for download",
  errored: "Patient Narrative generation failed",
};

export const PN_DOCUMENT_TYPE = {
  listing: "LISTING",
  cioms: "CIOMS",
};

export const SCS_DOCUMENT_TYPE = {
  gids: "GIDB",
  sdap: "SDAP",
  csrs: "CSR",
  iso: "ISO",
};
